module.exports = new __parcel__URL__("Mageskill_01.fae8ee40.png").toString();